module.exports = __webpack_public_path__ + "fonts/KlfXDe4B.woff2";